import React, { useState, useEffect } from 'react';
import './SearchBar.css';
import { Icon } from './Icon.js';

const SearchBar = ({ value, onChange, placeholder = 'Search...', onFocus, onBlur }) => {
  const [inputValue, setInputValue] = useState(value);

  // Debounce the search input
  useEffect(() => {
    const timer = setTimeout(() => {
      onChange(inputValue);
    }, 300);

    return () => clearTimeout(timer);
  }, [inputValue, onChange]);

  // Update local state when prop changes
  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleClear = () => {
    setInputValue('');
    onChange('');
  };

  const handleFocus = (e) => {
    if (onFocus) onFocus(e);
  };

  const handleBlur = (e) => {
    if (onBlur) {
      // Delay to allow click events on dropdown items
      setTimeout(() => {
        onBlur(e);
      }, 200);
    }
  };

  return (
    <div className="search-bar-wrapper" onFocus={handleFocus} onBlur={handleBlur}>
      <div className="search-input-wrapper">
        <Icon name="Search" className="search-icon" />
        <input
          type="text"
          className="search-input-field"
          value={inputValue}
          onChange={handleInputChange}
          placeholder={placeholder}
        />
        {inputValue && (
          <button className="clear-button" onClick={handleClear} title="Clear search">
            <Icon name="X" className="clear-icon" />
          </button>
        )}
      </div>
    </div>
  );
};

export default SearchBar; 